import type { SampleFormData } from './sampleFormSchema';

/** 重複登録など「情報」扱いのエラーか */
export function isSampleFormInfoError(error: string, duplicateHint: string): boolean {
  if (!error) return false;
  if (error.includes('duplicate_name_created_date')) return true;
  if (error.includes('duplicate_name_storage_date')) return true;
  const hint = duplicateHint.trim();
  return hint.length >= 8 && error.includes(hint.slice(0, 8));
}

/** バリデーション失敗時にフォーカスする要素 id */
export const SAMPLE_FORM_FIELD_ELEMENT_IDS: Partial<Record<keyof SampleFormData, string>> = {
  unit: 'sample-unit',
  name: 'sample-name',
  sampleType: 'sample-type',
  bslLevel: 'sample-bsl-level',
  initialQuantity: 'sample-initial-quantity',
  storageRoomId: 'storage-select',
  drawerNumber: 'sample-drawer-number',
  caseName: 'sample-case-name',
  notes: 'sample-notes',
  pathogenGenus: 'sample-pathogen-genus',
  pathogenSpecies: 'sample-pathogen-species',
  pathogenSubspecies: 'sample-pathogen-subspecies',
  pathogenStrain: 'sample-pathogen-strain',
  pathogenNote: 'sample-pathogen-note',
  drawerNote: 'sample-drawer-note',
};

export function focusSampleFormField(fieldKey: keyof SampleFormData | undefined): void {
  if (!fieldKey || typeof document === 'undefined') return;
  const id = SAMPLE_FORM_FIELD_ELEMENT_IDS[fieldKey];
  if (!id) return;
  const el = document.getElementById(id);
  if (!el) return;
  // sticky エラーバナー分の余白（バナーに隠れないように）
  el.style.scrollMarginTop = '5.5rem';
  el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  if ('focus' in el && typeof (el as HTMLElement).focus === 'function') {
    (el as HTMLElement).focus({ preventScroll: true });
  }
}
